<template>
  <client-only>
    <div class="icons">
      <div class="icon" @click="router.push(`/${prefix}/profile`)">
        <img class="profile-photo" :src="imageToShow">
      </div>

      <Popover :isOpen="isPopoverOpen" :width="225" :disabled="isPopoverDisabled" @update:isOpen="updatePopoverState">
        <template #trigger>
          <RoundedIcon src="/icons/dots.png"/>
        </template>
        <ul class="popover-menu">
          <li v-if="user?.admin"><a href="/dashboard">Dashboard</a></li>
          <li><a href="/field/profile"> Boards<img src="/icons/topright.png"/></a></li>
          <li><a href="/field/profile/settings"> Settings<img src="/icons/topright.png"/></a></li>
          <li><a href="/help"> Help Center<img src="/icons/topright.png"/></a></li>
          <li><a href="/terms-and-conditions"> Legal Terms <img src="/icons/topright.png"/></a></li>
          <li><a href="/about?q=contact"> Contact <img src="/icons/topright.png"/></a></li>
          <li @click="signOut">Log out</li>
        </ul>
      </Popover>
    </div>
  </client-only>
</template>
<script setup lang="ts">
import {useUserStore} from "~/composables/useUserStore";
import {useRouter} from "vue-router";
const router = useRouter();
const {user, logOut} = useUserStore();

const isPopoverOpen = ref(false);
const isPopoverDisabled = ref(false);

import {defineProps, ref} from 'vue';
import Popover from "~/components/Popover.vue";
import RoundedIcon from "~/components/RoundedIcon.vue";
defineProps({
  prefix: {
    type: String,
    default: 'viewer'
  }
});

const imageToShow = computed(() => {
  return user?.value?.profilePicture || user?.value?.role === 'artist' ? '/icons/profile_placeholder.png' : '/icons/profile_placeholder_brand.png';
});

const signOut = () => {
  logOut();
  router.push('/')
}
const updatePopoverState = (newState: any) => {
  isPopoverOpen.value = newState;
};

</script>
<style scoped>
.icons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.icon {
  width: 30px;
  height: 30px;
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.5);
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;
}

.icon:hover {
  border-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.icon img {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  border-radius: 50%;
}
.icon img.profile-photo {
  min-width: 28px;
}
.popover-menu {
  background: white;
  padding-top: 20px;

}
.popover-menu li img {
  max-width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid #b8b8b8;
  padding: 3px;
}
.popover-menu li:hover {
  background: #ededed;
  border-radius: 10px;
}
.popover-menu li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
  font-weight: 400;
  height: 44px;
  font-size: 14px;
  border-bottom: 0 !important;
  padding: 15px 20px;
}
</style>
